import React, { useState, useCallback } from 'react'
import { Layout } from 'antd'
import HeaderNavigation from '../../components/HeaderNavigation'
import { StockroomsTabView, EquipmentTabView, InventoryRequestsTabView } from '../../components/stockroom'
import { ProtectedTabs } from '../../components/RoleBasedAccess'

const { Content } = Layout

const tabsConfig = [
  {
    key: 'stockrooms',
    tab: 'Склады',
    component: <StockroomsTabView />,
    allowedRoles: ['project_manager', 'foreman'],
  },
  {
    key: 'equipment',
    tab: 'Оборудование на складе',
    component: <EquipmentTabView />,
    allowedRoles: ['project_manager', 'foreman', 'supplier'],
  },
  {
    key: 'requests',
    tab: 'Активные инвентарные заявки',
    component: <InventoryRequestsTabView />,
    allowedRoles: ['project_manager', 'foreman'],
  },
]

const Stockrooms = () => {
  const [tabSelectedState, setTabSelectedState] = useState('equipment')

  const onTabSelect = useCallback((key) => setTabSelectedState(key), [])

  return (
    <Layout>
      <HeaderNavigation activeKey="4" />
      <Content className="site-layout" style={{ padding: '85px 50px', minHeight: '100vh' }}>
        <ProtectedTabs tabsConfig={tabsConfig} onChange={onTabSelect} activeKey={tabSelectedState} />
      </Content>
    </Layout>
  )
}

export default Stockrooms
